import { IconName } from 'ui/components'

import * as SC from './styles'

type Props = {
  url?: string
  onClick?: () => void
}

export const DeleteItem = (props: Props) => {
  const { url, onClick } = props

  return (
    <SC.DeleteItem
      to={url}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault()
          onClick()
        }
      }}
      data-qa={`table-action-DELETE`}
    >
      <SC.WrappedIcon name={IconName.TRASH_OUTLINE} />
      <span>Delete</span>
    </SC.DeleteItem>
  )
}
